import { render, staticRenderFns } from "./yc-profit-page-detailed.vue?vue&type=template&id=06f70046&scoped=true&"
import script from "./yc-profit-page-detailed.vue?vue&type=script&lang=js&"
export * from "./yc-profit-page-detailed.vue?vue&type=script&lang=js&"
import style0 from "./yc-profit-page-detailed.vue?vue&type=style&index=0&id=06f70046&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f70046",
  null
  
)

export default component.exports